import React, {useContext} from "react";
import "./LinkedIn.scss";
import {linkedInSection} from "../../portfolio";
import {Fade} from "react-reveal";
import StyleContext from "../../contexts/StyleContext";

export default function LinkedIn() {
  const {isDark} = useContext(StyleContext);

  if (!linkedInSection.display) {
    return null;
  }
  return (
    // <div class="badge-base LI-profile-badge" data-locale="en_US" data-size="medium" data-theme="light" data-type="VERTICAL" data-vanity="sarthak-kumar-shailendra" data-version="v1"><a class="badge-base__link LI-simple-link" href="https://in.linkedin.com/in/sarthak-kumar-shailendra?trk=profile-badge">Sarthak Kumar Shailendra</a></div> 
    <div className="main" id="linkedIn">
      <div>
      <Fade bottom duration={1000} distance="20px">
      <div>
        <h1
              className={
                isDark
                  ? "dark-mode heading achievement-heading"
                  : "component-heading"
              }
            >
              {linkedInSection.title}
        </h1>
        <p
          className={
            isDark
              ? "dark-mode subTitle achievement-subtitle"
              : "subTitle component-subtitle"
          }
        >
         {linkedInSection.subtitle}
        </p>
        </div>
      </Fade>
      </div>
      <Fade bottom duration={2000} distance="20px">
      <div className="component-main">
      <div>
          <div>
          <iframe src="https://www.linkedin.com/embed/feed/update/urn:li:share:6985671496975151104" 
            frameborder="0" allowfullscreen="" title="Embedded post"/>
          </div>
        </div>
          <div className="content">
            <div className="content-overlay"
                            onClick={()=>{
                              window.open("https://www.linkedin.com/posts/sarthak-kumar-shailendra_pharmeasy-apiholdings-rewardsandrecognition-activity-6966836553931198464-ZdO2",
                            "_blank")
                          }}
                          ></div>
            <img src={require("../../assets/images/linkedIn_RisingStar.jpeg")} alt="LinkedIn" />
            <div className="linkedIn-details fadeIn-top"
                            onClick={()=>{
                              window.open("https://www.linkedin.com/posts/sarthak-kumar-shailendra_pharmeasy-apiholdings-rewardsandrecognition-activity-6966836553931198464-ZdO2",
                            "_blank")
                          }}
                          >
                  <h3>
                    VIEW POST
                  </h3>
            </div> 
          </div>
      </div>
      </Fade>
    </div>
  );
}
